import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=3532b4a8&scoped=true&"
import script from "./Addresses.vue?vue&type=script&lang=ts&"
export * from "./Addresses.vue?vue&type=script&lang=ts&"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=3532b4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532b4a8",
  null
  
)

export default component.exports